import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { IconErrorPage } from '../../assests/icons/Icons';
import { Button } from '../AllButton/AllButtons.tsx';
import { setModalHeaderFooter } from '../../ReduxTool/Slice/CommonReducers/CommonReducers';
import { useAppDispatch } from '../../ReduxTool/store/hooks';
 
const ErrorFallback = ({ error, resetErrorBoundary }: { error: any; resetErrorBoundary: any }) => (
  <div className="grid h-screen place-content-center bg-white px-4 relative z-20">
    <div className="text-center flex flex-col">
      <IconErrorPage />
      <h1 className="heading-lg-bold mt-6">Uh-oh!</h1>
      <p className="para-lg text-gray-500 m-2">{error?.message || "Unknown error occurred"}</p>
      <div className='flex gap-[10px]'>
        <Button
          className="btn btn-md-outlineprimary text-nowrap flex-1 pl-2 pr-2"
          name="Go Back Home"
          onClick={() => window.location.href = '/Consumer'}
        />
        <Button
          className='btn btn-md-primary w-full flex-1'
          name='Reload Page'
          onClick={() => window.location.reload()}
        />
      </div>
    </div>
  </div>
);
 
const OfflineFallback = () => (
  <div className="grid h-screen place-content-center bg-white px-4 relative z-20">
    <div className="text-center flex flex-col">
      <IconErrorPage />
      <h1 className="heading-lg-bold mt-6">You are offline!</h1>
      <p className="para-lg text-gray-500 m-2">Please check your internet connection.</p>
      <Button
        className='btn btn-md-primary w-full flex-1'
        name='Retry'
        onClick={() => window.location.reload()}
      />
    </div>
  </div>
);
 
const ErrorBoundarys: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const dispatch = useAppDispatch()
 
  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
 
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
 
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);
 
  if (isOffline) {
     dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"",isheader:true }));
    return <OfflineFallback />;
  }
 
  // dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"",isheader:false }));
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>
      {children}
    </ErrorBoundary>
  );
};
 
export default ErrorBoundarys;